import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemBlackSpottedMushroom extends Item {
    constructor() {
        super(definitions.ITEM_ID.BLACK_SPOTTED_MUSHROOMS, texture("prop_black_spotted_mushroom_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(3, 0));
    }
}